import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { useStoreState } from "pullstate";
import TextInput from "../FormComponents/TextInput";
import SingleDateInput from "../FormComponents/SingleDateInput";
import { clone, get, isEmpty, some } from "lodash";
import { useTranslation } from "react-i18next";
import SelectInput from "../FormComponents/SelectInput";
import Button from "../common/Button";
import classNames from "classnames";
import constants from "../../utils/constants";
import DateInput from "../FormComponents/DateInput";
import AwesomeIcon from "../AwesomeIcon";
import { faExclamationTriangle, faUsers } from "@fortawesome/pro-regular-svg-icons";
import Store from "../../utils/Store";
import { getIsOnpremise } from "../../utils";
import { differenceInYears, subYears } from "date-fns";
import { formatDate } from "../../utils";
import { faCopy } from "@fortawesome/pro-regular-svg-icons";
import MobileUpload from "../DicomUpload/ScanUpload/MobileUpload";
import { trackEvent } from "../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../utils/mixpanelEvents";
import invalidFileError from "../DicomUpload/InvalidError";
function PatientForm(_ref) {
  var _workspaceConfig$data, _workspaceConfig$data2, _get, _patient$name, _patient$age, _patient$additional$p, _patient$additional4, _patient$additional5, _patient$additional6, _patient$additional7, _patient$additional8;
  var isEditMode = _ref.isEditMode,
    onRegister = _ref.onRegister,
    patient = _ref.patient,
    setPatient = _ref.setPatient,
    isLoading = _ref.isLoading,
    error = _ref.error,
    hasNewFieldsInForm = _ref.hasNewFieldsInForm,
    selectedFiles = _ref.selectedFiles,
    _ref$checkedFilesLeng = _ref.checkedFilesLength,
    checkedFilesLength = _ref$checkedFilesLeng === void 0 ? 0 : _ref$checkedFilesLeng,
    requiredKey = _ref.requiredKey,
    isUploadInProgress = _ref.isUploadInProgress,
    showLoading = _ref.showLoading,
    isSinglePatient = _ref.isSinglePatient,
    selectedFilesKeys = _ref.selectedFilesKeys,
    formattedSelectedFiles = _ref.formattedSelectedFiles,
    onAddFile = _ref.onAddFile,
    setIsGuidelineModal = _ref.setIsGuidelineModal,
    patientDetails = _ref.patientDetails,
    onCloseModal = _ref.onCloseModal,
    setIsEdited = _ref.setIsEdited;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isOnpremise = getIsOnpremise();
  var isLC = process.env.NEXT_PUBLIC_IS_LC === "true";
  var _useStoreState = useStoreState(Store, function (s) {
      return {
        workspaceConfig: s.workspaceConfig
      };
    }),
    workspaceConfig = _useStoreState.workspaceConfig;
  var ageInputMode = (_workspaceConfig$data = workspaceConfig === null || workspaceConfig === void 0 || (_workspaceConfig$data2 = workspaceConfig.data) === null || _workspaceConfig$data2 === void 0 || (_workspaceConfig$data2 = _workspaceConfig$data2.ui_settings) === null || _workspaceConfig$data2 === void 0 || (_workspaceConfig$data2 = _workspaceConfig$data2.patient_edit_modal) === null || _workspaceConfig$data2 === void 0 ? void 0 : _workspaceConfig$data2.age_input_mode) !== null && _workspaceConfig$data !== void 0 ? _workspaceConfig$data : "dob";
  var showDobInsteadOfAge = ageInputMode === "dob" && isLC;
  var isFilesSelectionBlocking = checkedFilesLength <= 0 && !isEmpty(selectedFiles);

  // Match first-name input: legacy `name` counts when structured `first` is unset (nullish only).
  var lcPrimaryNameForValidation = (_get = get(patient, ["additional", "patient_name", "first"])) !== null && _get !== void 0 ? _get : patient === null || patient === void 0 ? void 0 : patient.name;
  var primaryNameMissing = isLC ? isEmpty(String(lcPrimaryNameForValidation !== null && lcPrimaryNameForValidation !== void 0 ? lcPrimaryNameForValidation : "").trim()) : isEmpty(String((_patient$name = patient === null || patient === void 0 ? void 0 : patient.name) !== null && _patient$name !== void 0 ? _patient$name : "").trim());
  var isRequiredPatientFieldsIncomplete = showDobInsteadOfAge ? primaryNameMissing || isEmpty(patient === null || patient === void 0 || (_patient$age = patient.age) === null || _patient$age === void 0 ? void 0 : _patient$age.toString()) || (patient === null || patient === void 0 ? void 0 : patient.gender) === "" || (patient === null || patient === void 0 ? void 0 : patient.gender) === undefined || (patient === null || patient === void 0 ? void 0 : patient.gender) === null || (patient === null || patient === void 0 ? void 0 : patient.gender) === 3 : some(requiredKey, function (value, key) {
    if (key === "name" && isLC) {
      return primaryNameMissing;
    }
    return isEmpty(value === null || value === void 0 ? void 0 : value.toString());
  });
  var onChangePatientId = function onChangePatientId(val) {
    var _patient = clone(patient);
    _patient.patient_id = val;
    if (val && setIsEdited) setIsEdited(true);
    setPatient(_patient);
  };
  var onChangeName = function onChangeName(val) {
    var _patient = clone(patient);
    _patient.name = val;
    if (val && setIsEdited) setIsEdited(true);
    setPatient(_patient);
  };
  var onChangeFirstName = function onChangeFirstName(val) {
    var _patient$additional;
    var _patient = clone(patient);
    _patient.additional = _objectSpread(_objectSpread({}, _patient.additional), {}, {
      patient_name: _objectSpread(_objectSpread({}, (_patient$additional = _patient.additional) === null || _patient$additional === void 0 ? void 0 : _patient$additional.patient_name), {}, {
        first: val
      })
    });
    setPatient(_patient);
  };
  var onChangeMiddleName = function onChangeMiddleName(val) {
    var _patient$additional2;
    var _patient = clone(patient);
    _patient.additional = _objectSpread(_objectSpread({}, _patient.additional), {}, {
      patient_name: _objectSpread(_objectSpread({}, (_patient$additional2 = _patient.additional) === null || _patient$additional2 === void 0 ? void 0 : _patient$additional2.patient_name), {}, {
        middle: val
      })
    });
    setPatient(_patient);
  };
  var onChangeLastName = function onChangeLastName(val) {
    var _patient$additional3;
    var _patient = clone(patient);
    _patient.additional = _objectSpread(_objectSpread({}, _patient.additional), {}, {
      patient_name: _objectSpread(_objectSpread({}, (_patient$additional3 = _patient.additional) === null || _patient$additional3 === void 0 ? void 0 : _patient$additional3.patient_name), {}, {
        last: val
      })
    });
    setPatient(_patient);
  };
  var onChangeRelativeName = function onChangeRelativeName(val) {
    var _patient = clone(patient);
    _patient.relative_name = val;
    if (val && setIsEdited) setIsEdited(true);
    setPatient(_patient);
  };
  var onChangeAge = function onChangeAge(val) {
    var re = /^[0-9\b]+$/;
    if (val === "" || re.test(val)) {
      var _patient = clone(patient);
      _patient.age = val;
      if (hasNewFieldsInForm) {
        _patient.dob = val ? subYears(new Date(), parseInt(val)) : null;
      }
      if (val && setIsEdited) setIsEdited(true);
      setPatient(_patient);
    }
  };
  var onChangeNumber = function onChangeNumber(val) {
    var _patient = clone(patient);
    _patient.contact = val;
    if (val !== "" && setIsEdited) setIsEdited(true);
    setPatient(_patient);
  };
  var onChangeGender = function onChangeGender(value) {
    var _patient = clone(patient);
    _patient.gender = value;
    if (value !== "" && setIsEdited) setIsEdited(true);
    setPatient(_patient);
  };
  var onChangeDOB = function onChangeDOB(val) {
    var _differenceInYears;
    var _patient = clone(patient);
    _patient.dob = val !== null && val !== void 0 ? val : null;
    _patient.age = val ? (_differenceInYears = differenceInYears(new Date(), val)) === null || _differenceInYears === void 0 ? void 0 : _differenceInYears.toString() : "";
    if (val && setIsEdited) setIsEdited(true);
    setPatient(_patient);
  };

  /* DOB picker: open above the field, compact calendar, avoid fixed dropdown + overlap issues */
  var dobDatePickerStyles = {
    input: {
      border: "none",
      borderWidth: 0,
      boxShadow: "none",
      color: "white",
      "&:focus": {
        border: "none",
        outline: "none",
        boxShadow: "none"
      },
      "&:focus-within": {
        border: "none",
        outline: "none",
        boxShadow: "none"
      }
    },
    dropdown: {
      marginTop: 0,
      marginBottom: 6,
      position: "absolute",
      paddingTop: 6,
      paddingBottom: 6,
      paddingLeft: 8,
      paddingRight: 8
    },
    calendarHeader: {
      marginBottom: 6
    },
    weekdayCell: {
      paddingBottom: 2
    },
    day: {
      width: 30,
      height: 30,
      minHeight: 30,
      fontSize: 12,
      lineHeight: "28px",
      padding: 0,
      "&[data-selected]": {
        backgroundColor: "#00A9A7"
      },
      "&[data-in-range]": {
        backgroundColor: "#D9DBDD"
      },
      "&[data-first-in-range]": {
        backgroundColor: "#00A9A7"
      },
      "&[data-last-in-range]": {
        backgroundColor: "#00A9A7"
      }
    },
    cell: {
      borderTop: "none"
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("form", {
    onSubmit: onRegister,
    className: classNames("flex-1 flex flex-col h-full sm:h-auto space-y-3 py-3 sm:py-0", {
      "sm:pt-6": isEditMode
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col h-full sm:overflow-visible"
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("flex flex-col sm:h-full gap-6 mt-2", {
      "px-5": isEditMode
    })
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: t("patient_id_label"),
    value: patient === null || patient === void 0 ? void 0 : patient.patient_id,
    autoComplete: "off",
    onChange: onChangePatientId,
    placeholder: t("patient_id_placeholder"),
    name: "patientId",
    id: "patientId",
    wrapperClassName: "my-0",
    labelClassName: classNames("!bg-gray-100 dark:!bg-gray-900 sm:!bg-gray-200 sm:dark:!bg-gray-800", {
      "!bg-gray-100 dark:!bg-gray-500": isEditMode
    }),
    inputClassName: "!bg-gray-100 sm:!bg-gray-200 dark:!bg-gray-900 sm:dark:!bg-gray-800",
    disabled: isEditMode || !isEmpty(selectedFiles) && checkedFilesLength <= 0 || hasNewFieldsInForm
  }), !isLC && /*#__PURE__*/React.createElement(TextInput, {
    label: t("full_name_label"),
    value: patient === null || patient === void 0 ? void 0 : patient.name,
    autoComplete: "off",
    onChange: onChangeName,
    placeholder: t("full_name_placeholder"),
    name: "fullName",
    id: "fullName",
    wrapperClassName: "my-0",
    labelClassName: "!bg-gray-100 dark:!bg-gray-900 sm:!bg-gray-200 sm:dark:!bg-gray-800",
    inputClassName: "!bg-gray-100 sm:!bg-gray-200 dark:!bg-gray-900 sm:dark:!bg-gray-800",
    required: isEmpty(selectedFiles),
    disabled: !isEmpty(selectedFiles) && checkedFilesLength <= 0
  }), isLC && /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-3 gap-2"
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "First Name",
    value: (_patient$additional$p = patient === null || patient === void 0 || (_patient$additional4 = patient.additional) === null || _patient$additional4 === void 0 || (_patient$additional4 = _patient$additional4.patient_name) === null || _patient$additional4 === void 0 ? void 0 : _patient$additional4.first) !== null && _patient$additional$p !== void 0 ? _patient$additional$p : patient === null || patient === void 0 ? void 0 : patient.name,
    autoComplete: "off",
    onChange: onChangeFirstName,
    placeholder: "",
    name: "firstName",
    id: "firstName",
    wrapperClassName: "my-0",
    labelClassName: "!bg-gray-100 dark:!bg-gray-900 sm:!bg-gray-200 sm:dark:!bg-gray-800",
    inputClassName: "!bg-gray-100 sm:!bg-gray-200 dark:!bg-gray-900 sm:dark:!bg-gray-800",
    required: isEmpty(selectedFiles),
    disabled: !isEmpty(selectedFiles) && checkedFilesLength <= 0
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Middle Name",
    value: (patient === null || patient === void 0 || (_patient$additional5 = patient.additional) === null || _patient$additional5 === void 0 || (_patient$additional5 = _patient$additional5.patient_name) === null || _patient$additional5 === void 0 ? void 0 : _patient$additional5.middle) || "",
    autoComplete: "off",
    onChange: onChangeMiddleName,
    placeholder: "",
    name: "middleName",
    id: "middleName",
    wrapperClassName: "my-0",
    labelClassName: "!bg-gray-100 dark:!bg-gray-900 sm:!bg-gray-200 sm:dark:!bg-gray-800",
    inputClassName: "!bg-gray-100 sm:!bg-gray-200 dark:!bg-gray-900 sm:dark:!bg-gray-800",
    required: false,
    disabled: !isEmpty(selectedFiles) && checkedFilesLength <= 0
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Last Name",
    value: (patient === null || patient === void 0 || (_patient$additional6 = patient.additional) === null || _patient$additional6 === void 0 || (_patient$additional6 = _patient$additional6.patient_name) === null || _patient$additional6 === void 0 ? void 0 : _patient$additional6.last) || "",
    autoComplete: "off",
    onChange: onChangeLastName,
    placeholder: "",
    name: "lastName",
    id: "lastName",
    wrapperClassName: "my-0",
    labelClassName: "!bg-gray-100 dark:!bg-gray-900 sm:!bg-gray-200 sm:dark:!bg-gray-800",
    inputClassName: "!bg-gray-100 sm:!bg-gray-200 dark:!bg-gray-900 sm:dark:!bg-gray-800",
    required: false,
    disabled: !isEmpty(selectedFiles) && checkedFilesLength <= 0
  })), isEditMode && (patient === null || patient === void 0 || (_patient$additional7 = patient.additional) === null || _patient$additional7 === void 0 || (_patient$additional7 = _patient$additional7.patient_name) === null || _patient$additional7 === void 0 ? void 0 : _patient$additional7.first) == null && (patient === null || patient === void 0 ? void 0 : patient.name) && /*#__PURE__*/React.createElement("div", {
    className: "text-yellow-500 text-md text-left flex gap-2 items-center"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faExclamationTriangle,
    size: "sm"
  }), "Full Name available, individual fields not provided")), hasNewFieldsInForm && /*#__PURE__*/React.createElement(TextInput, {
    label: t("father_name_label"),
    autoComplete: "off",
    value: patient === null || patient === void 0 ? void 0 : patient.relative_name,
    onChange: onChangeRelativeName,
    placeholder: t("father_name_placeholder"),
    name: "relativeName",
    id: "relativeName",
    wrapperClassName: "my-0",
    labelClassName: "!bg-gray-100 dark:!bg-gray-900 sm:!bg-gray-200 sm:dark:!bg-gray-800",
    inputClassName: "!bg-gray-100 sm:!bg-gray-200 dark:!bg-gray-900 sm:dark:!bg-gray-800",
    required: isEmpty(selectedFiles),
    disabled: !isEmpty(selectedFiles) && checkedFilesLength <= 0
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("flex my-0", {
      "gap-3": showDobInsteadOfAge
    })
  }, hasNewFieldsInForm && !showDobInsteadOfAge && /*#__PURE__*/React.createElement(DateInput, {
    id: "dob",
    value: patient !== null && patient !== void 0 && patient.dob ? new Date(patient === null || patient === void 0 ? void 0 : patient.dob) : patient === null || patient === void 0 ? void 0 : patient.dob,
    onChange: onChangeDOB,
    label: t("dob_label"),
    required: true,
    maxDate: new Date(),
    inputFormat: "MMM dd, yyyy",
    placeholder: t("select_date"),
    dropdownPosition: "top-start",
    className: "flex basis-1/2 mr-3"
  }), showDobInsteadOfAge ? /*#__PURE__*/React.createElement("div", {
    className: classNames("relative rounded-md py-3 px-2 text-gray-900 dark:text-gray-100 border border-gray-500", "flex min-w-0 flex-1 flex-col")
  }, /*#__PURE__*/React.createElement("label", {
    className: classNames("text-md !bg-gray-100 absolute z-10 left-4 -top-3 px-4 dark:!bg-gray-900 sm:!bg-gray-200 sm:dark:!bg-gray-800")
  }, t("dob_label"), " ", isEmpty(selectedFiles) && /*#__PURE__*/React.createElement("span", {
    className: "text-red-500 pl-2"
  }, "*")), /*#__PURE__*/React.createElement("div", {
    className: "w-full pt-1"
  }, /*#__PURE__*/React.createElement(SingleDateInput, {
    placeholder: "Birth Date",
    value: patient === null || patient === void 0 ? void 0 : patient.dob,
    onChange: onChangeDOB,
    inputFormat: "MMM DD, YYYY",
    classNames: "w-full",
    tooltip: t("dob_label"),
    options: {
      maxDate: new Date(),
      variant: "unstyled",
      /* Edit modal uses overflow-y-auto; top-start clips the header. Portal + flip avoids that. */
      withinPortal: !!isEditMode,
      dropdownPosition: isEditMode ? "flip" : "top-start",
      size: "xs",
      zIndex: isEditMode ? 10000 : 500
    },
    styles: dobDatePickerStyles
  }))) : /*#__PURE__*/React.createElement(TextInput, {
    label: t("age_label"),
    value: patient === null || patient === void 0 ? void 0 : patient.age,
    autoComplete: "off",
    onChange: onChangeAge,
    placeholder: t("age_label"),
    name: "age",
    id: "age",
    wrapperClassName: classNames("flex items-center mr-3 basis-1/3", {
      "!basis-1/2 flex !mr-0": hasNewFieldsInForm
    }),
    unit: "Yrs",
    required: isEmpty(selectedFiles),
    inputMode: "numeric",
    labelClassName: "!bg-gray-100 dark:!bg-gray-900 sm:!bg-gray-200 sm:dark:!bg-gray-800",
    inputClassName: "!bg-gray-100 sm:!bg-gray-200 dark:!bg-gray-900 sm:dark:!bg-gray-800",
    parentClassName: "w-full"
  }), (!hasNewFieldsInForm || showDobInsteadOfAge) && /*#__PURE__*/React.createElement(SelectInput, {
    value: patient === null || patient === void 0 ? void 0 : patient.gender,
    onChange: onChangeGender,
    options: constants.GENDERS,
    className: classNames("min-w-0", {
      "flex-1": showDobInsteadOfAge,
      "basis-2/3": !showDobInsteadOfAge
    }),
    label: t("gender_label"),
    required: isEmpty(selectedFiles),
    labelClassName: "!bg-gray-100 dark:!bg-gray-900 sm:!bg-gray-200 sm:dark:!bg-gray-800",
    disabled: !isEmpty(selectedFiles) && checkedFilesLength <= 0,
    dataTestId: "gender-select-input"
  })), isLC && isEditMode && (patient === null || patient === void 0 ? void 0 : patient.patient_uid) && !(patient !== null && patient !== void 0 && (_patient$additional8 = patient.additional) !== null && _patient$additional8 !== void 0 && _patient$additional8.is_dob_accurate) && /*#__PURE__*/React.createElement("div", {
    className: "text-yellow-500 text-md text-left flex gap-2 items-center"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faExclamationTriangle,
    size: "sm"
  }), /*#__PURE__*/React.createElement("span", null, "Date of birth could not be verified. Please confirm."))), /*#__PURE__*/React.createElement("div", {
    className: "flex my-0 mb-2"
  }, hasNewFieldsInForm && !showDobInsteadOfAge && /*#__PURE__*/React.createElement(SelectInput, {
    value: patient === null || patient === void 0 ? void 0 : patient.gender,
    onChange: onChangeGender,
    options: constants.GENDERS,
    className: "basis-1/2 mr-3",
    label: t("gender_label"),
    required: isEmpty(selectedFiles),
    labelClassName: "!bg-gray-100 dark:!bg-gray-900 sm:!bg-gray-200 sm:dark:!bg-gray-800",
    disabled: !isEmpty(selectedFiles) && checkedFilesLength <= 0,
    dataTestId: "gender-select-input"
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: t("Phone Number"),
    value: patient === null || patient === void 0 ? void 0 : patient.contact,
    onChange: onChangeNumber,
    placeholder: t("contact_placeholder"),
    name: "phoneNumber",
    id: "phoneNumber",
    maxLength: 15,
    required: hasNewFieldsInForm,
    wrapperClassName: hasNewFieldsInForm ? showDobInsteadOfAge ? "flex-1 w-full min-w-0" : "basis-1/2" : "flex-1",
    labelClassName: "!bg-gray-100 dark:!bg-gray-900 sm:!bg-gray-200 sm:dark:!bg-gray-800",
    inputClassName: "!bg-gray-100 sm:!bg-gray-200 dark:!bg-gray-900 sm:dark:!bg-gray-800",
    inputMode: "numeric",
    autoComplete: "off"
  })))), isEditMode && !isOnpremise && /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      Store.update(function (s) {
        s.isMatchingPatientOpen = true;
      });
      onCloseModal && onCloseModal();
      trackEvent(MIXPANEL_EVENTS.OPEN_MERGE_PATIENT, {
        source: "edit_patient",
        patient_uid: get(patientDetails, ["patient_uid"], "")
      });
    },
    className: "!mt-7 mb-5 px-5 text-teal-600 dark:text-teal-300 cursor-pointer hidden w-full md:flex justify-end items-center space-x-2"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faUsers,
    size: "lg",
    className: "w-5"
  }), /*#__PURE__*/React.createElement("p", {
    className: "text-[14px]"
  }, t("merge_patients"))), isSinglePatient && !isEmpty(formattedSelectedFiles) && /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col h-full text-gray-800 !overflow-hidden dark:text-white sm:hidden mt-6"
  }, showLoading ? /*#__PURE__*/React.createElement("p", {
    className: "text-gray-600 dark:text-gray-300 sm:hidden italic flex h-full justify-center items-center"
  }, t("loading_scans"), "...") : /*#__PURE__*/React.createElement("div", {
    className: "space-y-4 !h-full overflow-y-auto scrollbar-light dark:scrollbar"
  }, selectedFilesKeys === null || selectedFilesKeys === void 0 ? void 0 : selectedFilesKeys.map(function (fileKey, index) {
    var fileObject = formattedSelectedFiles[fileKey];
    var modality = get(fileObject, [0, "metaData", "Modality"], "");
    var studyDate = get(fileObject, [0, "metaData", "StudyDate"], "");
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "text-left p-5 border rounded-md border-gray-600 space-y-3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-6"
    }, /*#__PURE__*/React.createElement("p", {
      className: "col-span-2 text-md text-white/50"
    }, t("study_details")), /*#__PURE__*/React.createElement("p", {
      className: "col-span-4 text-md"
    }, formatDate(studyDate))), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-6"
    }, /*#__PURE__*/React.createElement("p", {
      className: "col-span-2 text-md text-white/50"
    }, t("series_instance")), /*#__PURE__*/React.createElement("div", {
      className: "col-span-4 items-center flex space-x-4"
    }, /*#__PURE__*/React.createElement("p", {
      className: "text-md"
    }, "".concat(modality)), /*#__PURE__*/React.createElement("div", {
      className: "flex space-x-2 items-center text-gray-700 dark:text-gray-500"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faCopy,
      size: "xs"
    }), /*#__PURE__*/React.createElement("p", {
      className: "text-md"
    }, fileObject === null || fileObject === void 0 ? void 0 : fileObject.length)))), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-6"
    }, /*#__PURE__*/React.createElement("p", {
      className: "col-span-2 text-md text-white/50"
    }, t("status")), /*#__PURE__*/React.createElement("div", {
      className: "col-span-4"
    }, invalidFileError({
      fileObject: fileObject
    }))));
  })), /*#__PURE__*/React.createElement(MobileUpload, {
    title: "upload_more_scans",
    onAddFile: onAddFile,
    setIsGuidelineModal: setIsGuidelineModal,
    className: classNames("hidden", {
      "!block": !isEmpty(formattedSelectedFiles)
    })
  })), /*#__PURE__*/React.createElement("div", {
    className: classNames("flex items-center flex-col sm:justify-between justify-end space-y-4 pb-4 sm:pb-0"
    // {
    //   "flex-1": !isSinglePatient,
    // }
    )
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-red-500 text-left sm:mb-0 px-5"
  }, error), /*#__PURE__*/React.createElement("div", {
    className: classNames("w-full", {
      "border-t border-gray-600 py-4 px-5": isEditMode
    })
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    isPrimary: true,
    "data-testid": isEditMode ? "update-patient-button" : "register-patient-button",
    disabled: isRequiredPatientFieldsIncomplete || isFilesSelectionBlocking,
    isLoading: isLoading || isUploadInProgress || showLoading,
    className: "grow-1 w-full !bg-teal-700 hover:!bg-teal-800 outline-none",
    onClick: onRegister
  }, isEditMode ? t("button.update") : t("button.register"))))));
}
export default PatientForm;